// extracted by mini-css-extract-plugin
module.exports = {"title":"tKnEX8","sup":"EJb0fC"};